export default {
  apiHost: 'https://web4me-api.suhmplus.com',
}
